<template>
  <container>
    <div v-if="$isDevMode()" class="dev-tools" style="margin-bottom: 20px; text-align: right;">
        <button class="btn btn--danger" @click="deleteAllRaces">Dev: Delete All</button>
    </div>
  <header class="live-run-inner">
    <race-list subtitle="in progress" :races="racesInProgress" v-if="racesInProgress.length !== 0" @delete="handleDeleteRace"></race-list>
    <race-list subtitle="to start" :races="racesToStart" message-empty-list="You don't have upcoming races." @delete="handleDeleteRace"></race-list>
   </header>
  </container>
</template>

<script>
import Container from '@/components/Container'
import RaceList from '@/components/Race/RaceList'
import RaceHeader from '@/components/Race/Header'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'live-run',
  data () {
    return {
      racesInProgress: [],
      racesToStart: []
    }
  },
  computed: {
    ...mapGetters({
      trainer: 'Trainer/trainer',
      races: 'RacesByTrainer/races',
      queue: 'LoadingQueue/queue',
      istrainer: 'LoadingQueue/istrainer'
    })
  },
  methods: {
    initialize () {
      this.addTaskToQueue('getTrainer')
      this.addTaskToQueue('getRacesByTrainer')

      this.getTrainer(this.$auth.user().id)
        .then(() => {
          this.removeTaskFromQueue('getTrainer')
        })
        .catch(() => {
         this.removeTaskFromQueue('getTrainer')
         this.removeTaskFromQueue('getRacesByTrainer')
         this.removeTaskFromQueue('getTrainerByUser')
         this.setIsTrainer(false)
         this.$auth.logout({redirect: '/login'})
        })
    },
    getRaces () {
      this.getRacesByTrainer(this.trainer.id)
        .then(() => {
          this.removeTaskFromQueue('getRacesByTrainer')
        })

    },
    setRacesInProgress () {
      this.racesInProgress = this.races.filter((race) => race.startDate !== null && race.finishDate === null)
    },
    setRacesToStart () {
      this.racesToStart = this.races.filter((race) => race.startDate === null && race.finishDate === null)
    },
    ...mapActions({
      getTrainer: 'Trainer/get',
      setIsTrainer: 'Trainer/setIsTrainer',
      getRacesByTrainer: 'RacesByTrainer/get',
      addTaskToQueue: 'LoadingQueue/addTaskToQueue',
      removeTaskFromQueue: 'LoadingQueue/removeTaskFromQueue',
      deleteOne: 'Race/deleteOne'
    }),
    deleteAllRaces () {
      if (!confirm('Dev Mode: Are you sure you want to delete ALL visible races?')) return
      
      const allRaces = [...this.racesInProgress, ...this.racesToStart]
      if (allRaces.length === 0) {
        alert('No races to delete')
        return
      }

      this.addTaskToQueue('deleteAllRaces')
      
      const promises = allRaces.map(race => this.deleteOne(race.id))
      
      Promise.all(promises)
        .then(() => {
          this.getRaces()
          this.removeTaskFromQueue('deleteAllRaces')
        })
        .catch(error => {
          console.error('Error deleting all races:', error)
          this.removeTaskFromQueue('deleteAllRaces')
        })
    },
    handleDeleteRace (raceId) {
       if (!confirm('Dev Mode: Delete this race?')) return
       
       this.addTaskToQueue('deleteRace')
       this.deleteOne(raceId)
        .then(() => {
          this.getRaces()
          this.removeTaskFromQueue('deleteRace')
        })
        .catch(error => {
          console.error('Error deleting race:', error)
          this.removeTaskFromQueue('deleteRace')
        })
    }
  },
  created () {
    this.initialize()
  },
  watch: {
    trainer () {
      this.getRaces()
    },
    races () {
      this.setRacesInProgress()
      this.setRacesToStart()
    }
  },
  components: {
    RaceList,
    Container,
    RaceHeader
  }
}
</script>



// WEBPACK FOOTER //
// LiveRun.vue?359c4282